import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './Footer.css';
import Logo from './Logo';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const navigate = useNavigate();
  const location = useLocation();

  const scrollToSection = (sectionId) => {
    // If not on home page, navigate to home first
    if (location.pathname !== '/') {
      navigate('/');
      setTimeout(() => {
        const element = document.getElementById(sectionId);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    } else {
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  };

  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-section">
          <Logo variant="footer" />
          <p className="footer-description">
            Your trusted partner in business excellence. We deliver innovative solutions 
            and professional services to help your business thrive.
          </p>
        </div>

        <div className="footer-section">
          <h4>Quick Links</h4>
          <ul className="footer-links">
            <li><a href="#home" onClick={(e) => { e.preventDefault(); scrollToSection('home'); }}>Home</a></li>
            <li><a href="#about" onClick={(e) => { e.preventDefault(); scrollToSection('about'); }}>About</a></li>
            <li><a href="#services" onClick={(e) => { e.preventDefault(); scrollToSection('services'); }}>Services</a></li>
            <li><a href="#contact" onClick={(e) => { e.preventDefault(); scrollToSection('contact'); }}>Contact</a></li>
          </ul>
        </div>

        <div className="footer-section">
          <h4>Contact Info</h4>
          <ul className="footer-contact">
            <li>📍 Gostinica BB, Uzice</li>
            <li>📍 31204, Serbia</li>
            <li>📞 +381 631983203</li>
            <li>👤 Nikola Baovic</li>
          </ul>
        </div>

        <div className="footer-section">
          <h4>Business Hours</h4>
          <ul className="footer-hours">
            <li>Monday - Friday</li>
            <li>9:00 AM - 5:00 PM</li>
            <li className="footer-timezone">Central European Time</li>
          </ul>
        </div>
      </div>

      <div className="footer-bottom">
        <p>&copy; {currentYear} Sami Rafael LLC. All rights reserved.</p>
        <p className="footer-credit">Designed with excellence and care</p>
      </div>
    </footer>
  );
};

export default Footer;

